import React from 'react';
import { Route } from 'react-router-dom';
import CreateTicket from '@/pages/tickets/CreateTicket';
import TicketReport from '@/pages/tickets/TicketReport';
import ResolveReport from '@/pages/tickets/ResolveReport';
import TicketUpdate from '@/pages/tickets/TicketUpdate';
import ScheduleMeeting from '@/pages/tickets/ScheduleMeeting';
import MeetingReport from '@/pages/tickets/MeetingReport';

export const ticketRoutes = (
  <React.Fragment>
    <Route path="tickets/create" element={<CreateTicket />} />
    <Route path="tickets/report" element={<TicketReport />} />
    <Route path="tickets/resolve" element={<ResolveReport />} />
    <Route path="tickets/update" element={<TicketUpdate />} />
    <Route path="tickets/schedule-meeting" element={<ScheduleMeeting />} />
    <Route path="tickets/meeting-report" element={<MeetingReport />} />
  </React.Fragment>
);
